import React from 'react';
import styled from 'styled-components';

import Alert from '@r1-frontend/ui-react/components/Alert';
import { InfoCircleFlip } from '@r1-frontend/ui-react/components/svg/main';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';

type TProps = {
    message: string | JSX.Element,
}

const BaseInfoToast = ({ message, ...props }: TProps) => (
    <Alert type={'info'} Icon={InfoCircleFlip} {...props}>
        <Paragraph4>
            {message}
        </Paragraph4>
    </Alert>
);

export default styled(BaseInfoToast)`
    max-width: 345px;
`;
